export default "__VITE_ASSET__CgXJE$ao__"